import { Entity, LiveData } from '@toeverything/infra';

import type { DocRecord, DocsService } from '../../doc';
import type { TemplateDocListStore } from '../store/list';

export class TemplateDocList extends Entity {
  constructor(
    public listStore: TemplateDocListStore,
    public docsService: DocsService
  ) {
    super();
  }

  public isTemplate$(docId: string) {
    return LiveData.from(this.listStore.watchTemplateDoc(docId), false);
  }

  /**
   * Ids of every doc flagged as template, including trashed ones.
   */
  public templateDocIds$ = LiveData.from(
    this.listStore.watchTemplateDocs(),
    [] as { id: string }[]
  ).map(list => list.map(property => property.id));

  /**
   * Same as {@link templateDocIds$}, without the docs that went to trash.
   */
  public liveTemplateDocIds$ = LiveData.computed(get => {
    const alive = new Set(get(this.docsService.list.nonTrashDocsIds$));
    return get(this.templateDocIds$).filter(id => alive.has(id));
  });

  public setTemplate(docId: string, isTemplate: boolean) {
    this.docsService.list
      .doc$(docId)
      .value?.setProperty('isTemplate', isTemplate);
  }

  public getTemplateDocs() {
    return this.listStore
      .getTemplateDocIds()
      .map(id => this.docsService.list.doc$(id).value)
      .filter((doc): doc is DocRecord => !!doc && !doc.trash$.value);
  }
}
